module.exports = __webpack_public_path__ + "static/img/no-img.3d8e8c8f.png";